// extracted by mini-css-extract-plugin
export default {"details":"details__ODljN","facets":"facets__MTI1O","location":"location__MGRkO","pricing":"pricing__NDliY","dot":"dot__MGUwM","detailsItem":"detailsItem__NDMzZ"};